const { send: ajax } = require('client/lib/request')
const analytics = require('client/lib/analytics')

module.exports = class ApplicationController {
  constructor() {
    this.setPageContext = analytics.setPageContext
  }

  teardown() {
    this.destroy()
    this.disconnect()
  }

  destroy() {
    if (this.scroller) {
      this.scroller.destroy()
    }
  }

  release() {
    if (this.scroller) {
      this.scroller.release()
    }
  }

  ajax(options) {
    const promise = ajax(options)
    const { req } = promise
    this.req = req
    return promise
    .finally(() => {
      if (req === this.req) {
        this.req = null
      }
    })
  }

  disconnect() {
    if (this.req) {
      this.req.abort()
      this.req = null
    }
  }

  paginationError(err) {
    this.destroy()
    throw err
  }
}
